import { Observable } from 'rxjs';
import { NodeComponent } from '../components/node-workspace/node/node.component';
import { ObjID } from './object-id.interface';
import { KeyValuePair } from './views.interface';
import { Point } from '@angular/cdk/drag-drop';

export interface NodeData {
	id: ObjID;
	type: NodeType;
	appName: string;
	appId: string;
	nodeTitle: string;
	friendlyName: string;
	vertexId?: ObjID;
	deleted?: boolean;
	children?: NodeData[];
	selected?: boolean;
	metadataList?: KeyValuePair[];
	segmentId?: string;
	isCritical?: boolean;
	location?: LatLonLocation;
}

export interface LatLonLocation {
	latitude: number;
	longitude: number;
	name?: string;
}

export interface Node extends NodeData {
	position: Point;
	workflowId?: ObjID;
}

export type NodeDroppedEvent = {
	nodeId: ObjID;
	position: Point;
};

export type NextNodeEvent = {
	initPoint: Point;
	data: NodeData;
};

export interface NodePortCoordinates {
	left: Point;
	right: Point;
}

export enum NodeType {
	inputOnly,
	inputOutput,
	outputOnly,
}

export enum GroupLevel {
	none,
	small,
	medium,
	large,
}

export type PortPressEvent = {
	mouseEvent?: MouseEvent;
	touchEvent?: TouchEvent;
	portType: PortType;
	node: NodeComponent;
	isTouch: boolean;
	touchPosition$?: Observable<TouchEvent>;
};

export type SnapToGridEvent = {
	node: NodeComponent;
	position: Point;
};

export enum PortType {
	inputPort,
	outputPort,
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
